type AuthUserMetadata = {
  given_name?: string
  family_name?: string
  first_name?: string
  last_name?: string
  full_name?: string
  name?: string
}

type AuthUserLike = {
  user_metadata?: AuthUserMetadata | null
}

function normalizeNamePart(value: string | undefined): string {
  return (value ?? '').trim()
}

function splitFullName(fullName: string): { firstName: string; lastName: string } {
  const parts = fullName
    .trim()
    .split(/\s+/)
    .filter(Boolean)

  if (parts.length === 0) {
    return { firstName: '', lastName: '' }
  }

  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' }
  }

  return {
    firstName: parts[0] ?? '',
    lastName: parts.slice(1).join(' '),
  }
}

export function extractOnboardingNamesFromAuthUser(user: AuthUserLike | null | undefined): {
  firstName: string
  lastName: string
} {
  const metadata = user?.user_metadata ?? {}

  const firstName = normalizeNamePart(metadata.given_name || metadata.first_name)
  const lastName = normalizeNamePart(metadata.family_name || metadata.last_name)

  if (firstName || lastName) {
    return { firstName, lastName }
  }

  const fullName = normalizeNamePart(metadata.full_name || metadata.name)
  if (!fullName) {
    return { firstName: '', lastName: '' }
  }

  return splitFullName(fullName)
}
